module.exports = __webpack_public_path__ + "static/media/best-seller.a1f5ac77.png";